import { render, staticRenderFns } from "./MediaPlayer.vue?vue&type=template&id=6b99841b&scoped=true&"
import script from "./MediaPlayer.vue?vue&type=script&lang=js&"
export * from "./MediaPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MediaPlayer.vue?vue&type=style&index=0&id=6b99841b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99841b",
  null
  
)

export default component.exports